import { render, staticRenderFns } from "./ClientEditSimple.vue?vue&type=template&id=02464fe0&"
import script from "./ClientEditSimple.js?vue&type=script&lang=js&"
export * from "./ClientEditSimple.js?vue&type=script&lang=js&"
import style0 from "./ClientEditSimple.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports